import { render, staticRenderFns } from "./TaskPointRank.vue?vue&type=template&id=7ad67f75&scoped=true"
import script from "./TaskPointRank.vue?vue&type=script&lang=js"
export * from "./TaskPointRank.vue?vue&type=script&lang=js"
import style0 from "./TaskPointRank.vue?vue&type=style&index=0&id=7ad67f75&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad67f75",
  null
  
)

export default component.exports